<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import ActionBar from '@/components/common/ActionBar.vue'
import RevisionSelect from '@/components/revision/RevisionSelect.vue'
import RevisionDialog from '@/components/revision/RevisionDialog.vue'
import StageConfigurationsTable from '@/components/stage-configuration/StageConfigurationsTable.vue'
import { REVISION_KEY } from '@/components/constant'

const route = useRoute()
const store = useStore()

const table = ref(null)

const revisionKey = computed(() => REVISION_KEY.STAGE_CONFIGURATION)

const revisionId = computed(() => {
  return parseInt(route.params.revisionId)
})

const hasStabSchematisationById = computed(() => (id) => {
  return store.getters['stageConfigurationRevision/hasStabSchematisationById'](id)
})

const isDisabled = computed(() => {
  return hasStabSchematisationById.value(revisionId.value)
})

const add = () => {
  table.value.add()
}
const save = () => {
  table.value.saveChanges()
}
</script>
<template>
  <div>
    <ActionBar
      class="pr-3 align-center"
      show-add 
      :disabled-add="isDisabled"
      :disabled-save="isDisabled"
      @add="add()"
      @save="save()"
      show-save
    >
      <template v-slot:left>
        <div class="d-flex align-center">
          <v-card-title> Stage configuration </v-card-title>
          <RevisionSelect
            label="Revision"
            style="width: 250px"
            class="float-right"
            density="compact"
            store-namespace="stageConfigurationRevision"
            :parameter="revisionKey"
          ></RevisionSelect>
        </div>
        <v-card-subtitle> Please define the stage configuration </v-card-subtitle>
      </template>
    </ActionBar>
    <StageConfigurationsTable class="pa-3" ref="table"></StageConfigurationsTable>
    <RevisionDialog
      store-namespace="stageConfigurationRevision"
      :parameter="revisionKey"
      allow-no-revision="true"
    ></RevisionDialog>
  </div>
</template>

<style scope>
.custom input[type='number'] {
  -moz-appearance: textfield;
}

.custom.v-text-field.v-text-field--enclosed .v-input__slot {
  padding-left: 2px !important;
}

tbody > tr:hover {
  background-color: transparent !important;
}
</style>